export { default as VictoryVoronoi } from "./victory-voronoi";
export { default as Voronoi } from "./voronoi";